import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { UrgencyService } from '../../service/urgency.service';

export const urgencyInterceptor: HttpInterceptorFn = (req, next) => {
  const urgencyService = inject(UrgencyService);
  if (!req.url.includes(urgencyService.factory.getApi())) {
    return next(req);
  }
  if (urgencyService.shouldSendHttpRequest()) {
    return next(req);
  }
  return of(
    new HttpResponse({
      status: 200,
      body: urgencyService.emergencies$$.getValue(),
    }),
  );
};
